import { FormattedMessage } from 'react-intl'

import { Badge } from '@gto/ui/badge'
import { Chip } from '@gto/ui/chip'
import { Typography } from '@gto/ui/typography'

import { type RedemptionOption } from '@/api/gen'
import { EdgeBalance } from '@/components/edge-balance'
import { useEdgeBalance } from '@/hooks/use-edge-balance'
import { SubscriptionKindEnum } from '@/pages/rewards/constants'

export const GtoSubscriptionCardHeader = ({
  subscription_level,
  cost,
  withSubGroup = false,
  subscription_type,
}: RedemptionOption & { withSubGroup?: boolean }) => {
  const { isDiscounted, loading: isFetching } = useEdgeBalance()

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-end justify-between">
        <div>
          {withSubGroup && (
            <div>
              <Chip
                color="primary"
                label={SubscriptionKindEnum[subscription_type]}
                size="small"
              />
            </div>
          )}
          {!isFetching && isDiscounted && (
            <Badge
              color="primary"
              variant="default"
            >
              <FormattedMessage id="edge.plansSection.firstSubscriptionDiscount" />
            </Badge>
          )}
          <Typography variant="h5">
            <FormattedMessage id={`edge.plansSection.level.${subscription_level}.title`} />
          </Typography>
        </div>
        <div className="text-right">
          {isDiscounted && (
            <Typography
              className="relative inline-block text-right before:absolute before:inset-x-0 before:top-1/2 before:z-[1] before:h-[1.5px] before:w-full before:translate-y-[-50%] before:rotate-[-15deg] before:bg-text-ghost before:content-['']"
              color="text.ghost"
              variant="body3"
            >
              {cost}
            </Typography>
          )}
          <EdgeBalance
            balance={isDiscounted ? cost * 0.5 : cost}
            typoProps={{
              className: 'text-[1.5rem] leading-[1]',
            }}
          />
        </div>
      </div>
      <Typography
        color="text.secondary"
        variant="body3"
      >
        <FormattedMessage id={`edge.plansSection.level.${subscription_level}.description`} />
      </Typography>
    </div>
  )
}
